const getSkuElement = (): Element | null => {
    return window.document.querySelector(`#add-to-wish-list-esi`);
};

export const getSkuId = (): string => {
    return getSkuElement()?.getAttribute('data-sku') ?? '';
};

export const getSkuSelected = (): boolean => {
    return getSkuElement()?.getAttribute('data-sku-selected') !== 'false' ?? false;
};

export const getProductDetails = (): string => {
    const addToWishlistElement = getSkuElement();
    return addToWishlistElement ? (addToWishlistElement.getAttribute('data-product-details') as string) : '';
};

export const getProductMetadata = (): string => {
    const addToWishlistElement = getSkuElement();
    return addToWishlistElement ? (addToWishlistElement.getAttribute('data-product-metadata') as string) : '';
};
